module.exports = __webpack_public_path__ + "img/product-forbidden-1.b839160b.png";